import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "color", "ignoreColor", "size"];
import { jsx as _jsx } from "react/jsx-runtime";
var Heart = function Heart(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24"
  }, other), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M12 21C11.734 21 11.48 20.895 11.292 20.706L3.52505 12.926C1.48905 10.886 1.48905 7.567 3.52505 5.527C4.50805 4.543 5.82105 4 7.22005 4C8.61905 4 9.93205 4.543 10.915 5.527L12 6.614L13.084 5.528C14.068 4.543 15.381 4 16.78 4C18.179 4 19.492 4.543 20.475 5.527C22.511 7.567 22.511 10.886 20.476 12.926L12.708 20.707C12.52 20.895 12.266 21 12 21Z"
    })
  }));
};
export default Heart;